// If this ever throws it means that a precondition has been broken and we can't fulfill the request
export function impossible(tag: string): never {
  throw new Error(`Impossible: ${tag}`);
}

export function error(reason: string): never {
  throw new Error(reason);
}

// TODO set a lint
export function unimplemented(reason?: string): never {
  throw new Error(`Unimplemented: ${reason}`);
}

export function unreachable(evidence: never): never {
  return evidence;
}

export function unsupported(reason?: string): never {
  throw new Error(`Unsupported: ${reason}`);
}
